import { AnimationSpine } from 'core/display/spines/AnimationSpine'
import { ModuleSettingsService } from 'services/ModuleSettingsService'
import { signal } from 'services/SignalsService'
import { assets } from 'utils/AssetParser'
import { SpineUtils } from 'utils/Spine-Utils'

import GambleDynamicText from './GambleDynamicText'
import { GambleService } from './GambleService'
import GambleTitle from './GambleTitle'
import HistorySpine from './HistorySpine'

export default class GambleSpine extends AnimationSpine {
  constructor(data) {
    super(data)

    if(data.module) {
      ModuleSettingsService.init()
      this._settings = ModuleSettingsService.getConfig(data.module)
    }
    this.card = null

    this._historySpine = []

    this._counterCard = 0

    this._texts = {
      leftTitle: 0,
      totalWinValue: 0,
      gambleWinValue: 0,
    }

    this._handlers = [this._chooseGamble.bind(this), this._chooseGamble.bind(this), this._closeGamble.bind(this)]

    this.init()
  }

  addModuleSignals(){
    signal.on(this._settings.signal.winAnim, () => {
      this.replaceCardTexture()
      this.animationPlay()
    })
    signal.on('STATE:OUT:INIT', () => {
      if(game.models.GambleModel.get().rest > 0){
        signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
      }
      if(game.models.GambleModel.get().win > 0){
        signal.dispatch(this._settings.signal.gambleWinText, { type: 'gamble', amount: game.models.GambleModel.get().win })
        signal.dispatch('NET:POSITION:CLEAN')
      }
    })
    signal.on('RADIO:menu:all', () => {
      if(game.models.GambleModel.get().rest > 0 || game.models.SpinModel.get().actions.length > 1){
        signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
      }
    })
    signal.on(this._settings.signal.close, () => {
      this.hide()
    })
    signal.on(this._settings.signal.open, () => {
      this.show()
    })
    signal.on(this._settings.signal.choice, (value) => {
      this.setInteractivityChild(false)
      this._setGamble(true)
      game.models.GambleModel.setCard(`${value}`)
      signal.dispatch(this._settings.signal.getCard)
    })
  }

  init(){
    this._addHandler(this.buttons)
    this._createTexts()
    this._createHistorySpine()
    this._getCardSprite()
    this.addModuleSignals()
    this.updateGamble()
    this.updateHistory(GambleService.getHistory())
  }

  _createTexts(){
    this._settings.texts.forEach((params) => {
      const text =  params.class === 'title' ? new GambleTitle(params) : new GambleDynamicText(params)
      this._texts[params.name] = text
      SpineUtils.addText(this, params.slotName, text, params.pos)
    })
  }

  _createHistorySpine(){
    this._settings.history.spine.forEach((params) => {
      params.spineData = assets.spine.gambleHistory.spineData

      const spine = new HistorySpine(params)
      spine.skeleton.setSkinByName(params.skin)
      spine.skeleton.setToSetupPose()
      spine.state.setAnimation(0, this._settings.history.animation.idle, true)
      SpineUtils.addSpine(this, params.slotName, spine, params.pos)

      this._historySpine.push(spine)
    })
  }

  _chooseGamble(index){
    signal.dispatch(this._settings.signal.choice, index)
    signal.dispatch(index ? this._settings.signal.gambleSpades : this._settings.signal.gambleHearts)
  }

  _closeGamble(){
    signal.dispatch(this._settings.signal.close)
  }

  _getCardSprite(){
    this.playCallBack('win-in', false, () => {
      const card = this.getSpineSlotByName('card_simple')
      this.card = card.sprites['card_hearts']
      this.setToSetupPose()
      this.play('cards-idle', false).then(() => {
        this.setToSetupPose()
      })
    })
  }

  _addHandler(buttons){
    this._handlers.forEach((handler, index) => {
      buttons[index].handler = handler
    })
  }

  _getCorrectHistoryTex(value){
    const textures =  this._settings.base.textures
    return value === '0' ? this._getTexture(textures.red) : this._getTexture(textures.black)
  }

  _getCorrectTex(){
    const textures =  this._settings.base.textures
    const gambleModel = game.models.GambleModel.get()
    return gambleModel.winCard === '0' ? this._getTexture(textures.red) : this._getTexture(textures.black)
  }

  _getTexture(name){
    return game.getTextureFromAtlases(name)
  }

  _cleanHistorySlot(){
    this._counterCard = 0
    this._historySpine.forEach((spine) => {
      spine.skeleton.setToSetupPose()
      spine.updateTextKey('close')
      spine.state.setAnimation(0, this._settings.history.animation.idle, true)
    })
  }

  _getCorrectSpine(){
    return this._historySpine[this._counterCard]
  }

  updateGamble(){
    this.updateLeftCounter(GambleService.getTry())
    this.updateTotalWin(GambleService.getWin())
    this.updateGambleWin(GambleService.getWin())
  }

  updateHistory(value){
    if(value === null) {
      this._cleanHistorySlot()
      return
    }
    const historyLength = value.length
    this._counterCard = historyLength

    value.forEach((data, index) => {
      const historySpine =  this._historySpine[index]
      this.replaceHistoryCard(data, historySpine)
    })
  }

  replaceHistoryCard(win, correctSpine){
    const spine = correctSpine
    const winTex = this._getCorrectHistoryTex(win)
    const sprite = new PIXI.Sprite(winTex)
    sprite.anchor.set(0.5)
    SpineUtils.replaceSprite(spine, 'card_b1', sprite)
    spine.updateTextKey(win)
    spine.playCallBack(this._settings.history.animation.in, false, () => {
      spine.state.setAnimation(0, this._settings.history.animation.loop, true)
    })
  }

  replaceCardTexture(){
    const slot = this.getSpineSlotByName('card_simple')
    const card = slot.sprites['card_hearts']
    card.texture = this._getCorrectTex()
  }

  animationPlay(){
    const anim = this._settings.gamble.animations
    const winCard = game.models.GambleModel.get().winCard
    this.replaceHistoryCard( winCard, this._getCorrectSpine())
    this.playCallBack(anim.winIn, false, () => {
      this.updateGamble()
      this._counterCard++
      signal.dispatch(this._settings.signal.updateBalance)
      this.playCallBack(anim.winLoop, false, () => {
        this.playCallBack(anim.winOut, false, () => {
          signal.dispatch(this._settings.signal.done)
          this.playCallBack(anim.idle, true)
          this.checkWin()
        })
      })
    })
  }

  _setGamble(value){
    game.models.GambleModel.setStartGamble(value)
    game.models.GambleModel.setIsGamble(value)
  }

  startGame(){
    signal.dispatch(this._settings.signal.gambleWinText, { type: 'gamble', amount: game.models.GambleModel.get().endWin })
    this.setInteractivityChild(true)
    this._setGamble(true)
  }

  finishGame(){
    if (this._counterCard === 4 && game.models.GambleModel.get().endWin) {
      signal.dispatch(this._settings.signal.gambleWin)
      signal.dispatch(this._settings.signal.gambleWinText, { type: 'gamble', amount: game.models.GambleModel.get().endWin })
    }
    else {
      signal.dispatch(this._settings.signal.gambleLoseText, { type: 'gamble', amount: 0 })
    }

    this.setInteractivityChild(false)
    this._setGamble(false)

    signal.dispatch(this._settings.signal.hideButton)
    signal.dispatch(this._settings.signal.close)
  }

  checkWin(){
    if(game.models.GambleModel.get().rest > 0){
      this.startGame()
    }
    else{
      this.finishGame()
    }
  }

  show(){
    this.updateHistory(GambleService.getHistory())
    this.setInteractivityChild(true)

    this.updateGamble()
    this.playCallBack('0-animation', false, () => {
      this.playCallBack('gamble-in', false )
      this.playCallBack('cards-idle', true)
    })
  }

  hide(){
    this._setGamble(false)
    this.updateHistory(GambleService.getHistory())
    this.playCallBack('gamble-out', false, () => {
    })
  }

  updateLeftCounter(value){
    this._texts.leftTitle.updateValueWithText(value)
  }

  updateTotalWin(value){
    const gambleModel = game.models.GambleModel
    const rest = gambleModel.get().rest
    if(this._counterCard > 0){
      this._texts.totalWinValue.update(rest > 0 ? value : 0)
    }
    else{
      this._texts.totalWinValue.update(value)
    }

  }

  updateGambleWin(value){
    const gambleModel = game.models.GambleModel
    const rest = gambleModel.get().rest

    if(this._counterCard > 0){
      this._texts.gambleWinValue.update(rest > 0 ? value * 2 : 0)
    }
    else{
      this._texts.gambleWinValue.update(value * 2)
    }
  }
}
